import React, { Component } from 'react';
import { Button, Card, message, Table } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { queryFileList, queryFilePreview, querySaveAttachment } from '@api/pub/attachment';
import baseData from '@util/base';
import util from '@util/index';
import ModalFile from './ModalFile';

class CardFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    this.getFileList();
  }

  submit = params => {
    querySaveAttachment({
      ...params,
      itemUuid: this.props.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.getFileList();
        this.handleVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  getFileList = () => {
    const pageSize = 10;
    queryFileList({
      itemUuid: this.props.customUuid,
      ...this.sorter,
      start: this.current || 1,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: util.formatTableData(res.data, 'type'),
            pagination: {
              current: this.current || 1,
              total: res.totalSize,
              pageSize,
            },
          },
        });
      }
    });
  };

  getType = type => {
    const index = baseData.attachmentType.findIndex(item => +item.key === +type);
    return baseData.attachmentType[index].name;
  };

  handleVisible = (flag, fileParams) => {
    this.fileData = {};
    if (fileParams) {
      this.fileData = {
        type: fileParams.type,
        files: [
          {
            uuid: fileParams.uuid,
            name: fileParams.name,
            url: fileParams.url,
          },
        ],
      };
    }
    this.setState({
      visible: !!flag,
    });
  };

  columns = () => {
    return [
      {
        title: '文件类型',
        dataIndex: 'type',
        key: 'type',
        sorter: true,
        render: (text, record, index) => {
          return {
            children: <span>{this.getType(text)}</span>,
            props: {
              rowSpan: record.rowSpan,
            },
          };
        },
      },
      {
        title: '源文件',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => <a onClick={() => queryFilePreview(record)}>{text}</a>,
      },
      {
        title: '添加时间',
        dataIndex: 'createDate',
        sorter: true,
        render: (text, record) => {
          return moment.unix(text / 1000).format('YYYY-MM-DD');
        },
      },
      {
        title: '添加人',
        dataIndex: 'createName',
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return <a onClick={() => this.handleVisible(true, record)}>编辑</a>;
        },
      },
    ];
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    if (sorter) {
      this.sorter = {
        sorts: `${sorter.field === 'type' ? 'pubatmType' : 'pubatmCdate'},${
          sorter.order ? sorter.order.replace('end', '') : 'desc'
        }`,
      };
    }
    this.getFileList();
  };

  render() {
    const { customUuid } = this.props;
    const {
      dataSource: { list, pagination },
      loading,
      visible,
    } = this.state;
    const extra = <Button onClick={this.handleVisible}>上传附件</Button>;
    return (
      <Card title="附件信息" style={{ marginBottom: '16px' }} extra={extra}>
        <Table
          bordered
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          rowKey="uuid"
          onChange={this.handleTableChange}
          loading={loading}
        />
        <ModalFile
          customUuid={customUuid}
          visible={visible}
          handleCancel={this.handleVisible}
          handleOk={this.submit}
          fileData={this.fileData}
        />
      </Card>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(CardFile);



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/CardFile.js